/** A referential catalogue: no tenant, no parameter. */
class FetchAiUsages {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAiUsages;
